<template>
<v-container fluid>
<v-row row wrap>
<v-flex xs12 lg8 md6>
<v-card>
   <v-snackbar
    ma-10
    v-model="snackbar"
    :color="snackbarColor"
    :top="true"
    :right="true"
    :timeout="6000"
    absolute
    >
    {{ message }}
    <v-btn
      dark
      text
      @click="snackbar = false"
    >
      CLOSE
    </v-btn>
  </v-snackbar>
  <v-form ref="form" v-model="valid" lazy-validation>
  <v-flex pa-4>
  <v-text-field
    name="firstname"
    label="First Name"
    v-model="user.firstName"
    :rules="firstNameRules"
    required>
  </v-text-field>

  <v-text-field
   name="lastname"
   label="Last Name"
   v-model="user.lastName"
   :rules="lastNameRules"
   required
   >
  </v-text-field>

  <v-text-field
   name="username"
   label="Username"
   v-model="user.username"
   :rules="userNameRules"
   required
   >
  </v-text-field>
  <v-select
  :items="roleNames"
  label="Role"
  v-model="user.role"
  solo
  :rules="roleRules"
  required
  >
  </v-select>
  <v-select v-model="user.department" v-bind:items="departments"  item-text="label"  item-value="value" :placement="placement" label="Department"></v-select>
  </v-flex>

  <v-card-actions>
    <v-btn @click="createInternalUser" color="primary">Create User</v-btn>
  </v-card-actions>
  </v-form>
</v-card>
</v-flex>
</v-row>
</v-container>
</template>
<script>
import axios from 'axios'
import config from '../../../config'

export default {
  name: 'createinternaluser',
  data: function () {
    return {
      user: {
        firstName: '',
        lastName: '',
        username: '',
        role: ''
      },
      roles: [],
      roleNames: [],
      departments: [{ value: 'ICT', label: 'ICT' }, { value: 'FTS', label: 'FTS' }, { value: 'AGRIC-COOP', label: 'AGRIC-COOP' }, { value: 'BOS', label: 'BOS' }, { value: 'COU', label: 'COU' }, { value: 'AUDIT', label: 'AUDIT' },{ value: 'BRANCH', label: 'BRANCH' },{ value: 'CONTACT CENTRE', label: 'CONTACT CENTRE' }],
      placement: 'down',
      valid: true,
      firstNameRules: [
        v => !!v || 'First Name is required'
      ],
      lastNameRules: [
        v => !!v || 'Last Name is required'
      ],
      userNameRules: [
        v => !!v || 'Username is required'
      ],
      roleRules: [
        v => !!v || 'Role is required'
      ],
      message: '',
      snackbar: false,
      snackbarColor: ''
    }
  },
  mounted () {
    this.getRoles()
  },
  methods: {
    createInternalUser () {
      if (this.$refs.form.validate()) {
        var url = config.serverURI + '/user/internaluser/create'
        console.log(this.user)
        axios.post(url, this.user)
          .then(response => {
            if (response.status !== 200) {
              this.message = response.statusText
              this.snackbar = true
              this.snackbarColor = 'error'
              console.log('Error is ' + this.error)
              return
            }
            if (response.data.error !== false) {
              this.message = response.data.message
              this.snackbar = true
              this.snackbarColor = 'error'
              console.log('Error is ' + this.error)
              return
            }
            this.resetUserObject()
            this.$refs.form.reset()
            this.message = response.data.message
            this.snackbar = true
            this.snackbarColor = 'primary'
          })
          .catch(error => {
            console.log('error', error.response)
            this.message = error.response.message
            this.snackbar = true
            this.snackbarColor = 'error'
          })
      }
    },
    resetUserObject () {
      this.user.firstName = ' '
      this.user.lastName = ' '
      this.user.username = ' '
      this.user.role = ' '
    },
    getRoles () {
      var url = config.serverURI + '/admin/role/getAllInternal'
      axios.get(url)
        .then(response => {
          if (response.status !== 200) {
            console.log('Error is ' + this.error)
            return
          }
          this.roles = response.data
          const mapFunction = p => p.name
          this.roleNames = this.roles.map(mapFunction)
        })
        .catch(error => {
          console.log('error', error.response)
        })
    }
  }
}

</script>
<style>
</style>
